import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/digitale-demokratie")({
  beforeLoad: () => {
    throw redirect({
      to: "/$languageKey/$topicSlug/$pageSlug",
      params: {
        languageKey: "de",
        topicSlug: "demokratie",
        pageSlug: "digitale-demokratie",
      },
      statusCode: 301,
    });
  },
});
